<div class="container" wmFrontSize (widthChanged)="onSizeChanged($event)">
  @for (configuration of insideFiltersConfigurations(); track configuration) {
  <wm-front-simple-filter
    [configuration]="configuration"
    [value]="
      values()
        ? values()![configuration.key || configuration.dataType]
        : undefined
    "
    [reset]="resetFilter$()"
    (changeEvent)="onFilterChanged($event)"
  ></wm-front-simple-filter>
  }
  <div
    class="responsive-container"
    [style.display]="outsideFiltersConfigurations()?.length ? 'block' : 'none'"
    (clickOutside)="displayResponsiveFilters.set(false)"
  >
    @if (!minimizedMode()) {
    <button
      #responsiveToggler
      wm-front-button
      status="primary"
      [outline]="true"
      [flat]="true"
      (click)="displayResponsiveFilters.set(!displayResponsiveFilters())"
    >
      @if (pinnedLayout()) {
      <mat-icon class="filters-icon" svgIcon="filter-sm"></mat-icon>
      } @if (!insideFiltersConfigurations()?.length || pinnedLayout()) {
      <span
        i18n="
          Button label | Label for the filters button when only
          button@@FiltersResponsiveFiltersButton"
      >
        Filtres
      </span>
      } @if (insideFiltersConfigurations()?.length > 0 && !pinnedLayout()) {
      <span
        i18n="
          Button label | Label for the filters button when both inline and
          responsive buttons@@MoreFiltersResponsiveFiltersButton"
      >
        Plus de filtres
      </span>
      } @if (numberOfResponsiveFilterWhichHaveValue()) {
      <span class="count">
        {{ numberOfResponsiveFilterWhichHaveValue() | number }}
      </span>
      }
    </button>
    } @else {
    <wm-front-icon-button
      icon="filter-sm"
      #responsiveToggler
      [count]="numberOfResponsiveFilterWhichHaveValue()"
      [status]="'primary'"
      [countColor]="'warning'"
      (click)="displayResponsiveFilters.set(!displayResponsiveFilters())"
    ></wm-front-icon-button>
    }
    <div
      class="responsive-menu"
      [style.display]="displayResponsiveFilters() ? 'flex' : 'none'"
      [class.align-right]="responsiveFilterShouldAlignToTheRight()"
      #responsiveMenu
      [style.width.px]="filterDropdownWidth()"
    >
      @for (configuration of outsideFiltersConfigurations(); track
      configuration) {
      <wm-front-simple-filter
        [style.display]="
          (responsiveFilterOpened() &&
            responsiveFilterOpened() ===
              (configuration.key || configuration.dataType)) ||
          !responsiveFilterOpened()
            ? 'initial'
            : 'none'
        "
        [configuration]="configuration"
        [value]="
          values()
            ? values()![configuration.key || configuration.dataType]
            : undefined
        "
        [reset]="resetFilter$()"
        [isResponsive]="true"
        (openEvent)="manageOpenChange(configuration, $event)"
        (changeEvent)="onFilterChanged($event)"
      ></wm-front-simple-filter>
      } @if (!responsiveFilterOpened()) {
      <div class="responsive-list-reset-filters">
        <button
          class="reset-filters"
          (click)="resetResponsiveFilters()"
          wm-front-button
          status="primary"
          [outline]="true"
          [disabled]="!numberOfResponsiveFilterWhichHaveValue()"
          [flat]="true"
          i18n="
            Button label | Label for the reset all filters
            button@@FiltersResetFiltersButton"
        >
          Réinitialiser tous les filtres
        </button>
      </div>
      }
    </div>
  </div>
</div>
